import zhCN from 'vant/es/locale/lang/zh-CN';
import enUS from 'vant/es/locale/lang/en-US';
import zhTW from 'vant/es/locale/lang/zh-TW';

import zhCN_APP from './language/zh-CN';
import enUS_APP from './language/en-US';
import zhTW_APP from './language/zh-TW';
import msMY_APP from './language/ms-MY';
import quoteZhCN from '@/views/quote/locales/zh-CN';
import quoteZhTW from '@/views/quote/locales/zh-TW';
import quoteEnUS from '@/views/quote/locales/en-US';

export default {
    'zh-CN': {
        van: zhCN, // Vant 的中文语言包
        app: zhCN_APP.app,
        quote: quoteZhCN,
    },
    'zh-TW': {
        van: zhTW,
        app: zhTW_APP.app,
        quote: quoteZhTW,
    },
    'en-US': {
        van: enUS, // Vant 的英文语言包
        app: enUS_APP.app,
        quote: quoteEnUS,
    },
    'ms-MY': {
        // Vant 无马来语语言包，回退英文；报价模块保持其自身的语言机制
        van: enUS,
        app: msMY_APP.app,
        quote: quoteEnUS,
    },
};
